<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import SidebarLayout from '@/layout/SidebarLayout.vue';
import SecurityTrim from '@/components/ui/SecurityTrim.vue';
import IdSearchHeader from '@/components/ui/IdSearchHeader.vue';
import type { IdSearch } from '@/components/ui/IdSearch';
import PaymentDetailPanel from '@/components/payments/PaymentDetailPanel.vue';
import { AccountActions } from '@/integrations/Immersve/auth/actions';

const paymentSearch: IdSearch = {
  name: 'payment',
  title: 'Payment',
  subtitle: 'A card payment, by payment ID.',
  label: 'Payment ID',
  read: (route) => route.params.paymentId,
  to: (id) => `/payments/${encodeURIComponent(id)}`,
  clearPath: '/payments',
};

const route = useRoute();

const paymentId = computed(() =>
  typeof route.params.paymentId === 'string' ? route.params.paymentId : ''
);
</script>

<template>
  <SidebarLayout>
    <SecurityTrim :actions="[AccountActions.Read]" account-id="*">
      <div class="px-4 py-6 md:px-8" data-test="screen-payment">
        <IdSearchHeader :searches="[paymentSearch]" />
        <PaymentDetailPanel v-if="paymentId" :payment-id="paymentId" />
        <p v-else class="text-sm text-gray-500" data-test="payment-prompt">
          Enter a payment ID to see its details.
        </p>
      </div>
    </SecurityTrim>
  </SidebarLayout>
</template>
